module.exports = __webpack_public_path__ + "img/ИФ-1(А)-005.de0f8d21.png";